import { Canvas } from '@react-three/fiber'
import { useGLTF, OrbitControls, Float, Stars } from '@react-three/drei'
import { NodeToyMaterial, NodeToyTick } from '@nodetoy/react-nodetoy'
import { data } from './shaderData.jsx';
import { dataa } from './shaderDataa.jsx';

export default function App() {
  return (
    <Canvas
      camera={{ position: [0, 1.5, 5], fov: 35 }}
      dpr={[1, 1.5]}
    >
      {/* Qora fon */}
      <color attach="background" args={['#0a0a15']} />

      {/* Yulduzlar - kamroq */}
      <Stars
        radius={80}
        depth={40}
        count={1500}
        factor={3}
        saturation={0}
        fade
        speed={0.5}
      />

      {/* Oddiy yorug'liklar */}
      <ambientLight intensity={0.6} />
      <directionalLight position={[5, 5, 5]} intensity={1} />
      <pointLight position={[-3, 2, -3]} intensity={0.3} color="#6080ff" />

      <NodeToyTick />

      {/* Kiyim - Float effekti */}
      <Float
        speed={1.2}
        rotationIntensity={0.1}
        floatIntensity={0.15}
      >
        <Shoe position={[0, 0.2, 0]} />
      </Float>

      {/* Oddiy pol - past reflection */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.6, 0]}>
        <circleGeometry args={[6, 64]} />
        <meshStandardMaterial
          color="#0a0a15"
          metalness={0.1}
          roughness={0.8}
        />
      </mesh>

      {/* OrbitControls */}
      <OrbitControls
        enablePan={false}
        minPolarAngle={Math.PI / 4}
        maxPolarAngle={Math.PI / 2.2}
        minDistance={4}
        maxDistance={10}
        enableDamping
        dampingFactor={0.05}
      />
    </Canvas>
  )
}

function Shoe(props) {
  const { nodes, materials } = useGLTF('/shoe.gltf')
  return (
    <group {...props} dispose={null}>
      <mesh  geometry={nodes.shoe.geometry} material={materials.laces} />
      <mesh  geometry={nodes.shoe_1.geometry} ><NodeToyMaterial data={dataa} /></mesh>
      <mesh  geometry={nodes.shoe_2.geometry} ><NodeToyMaterial data={data} /></mesh>
      <mesh  geometry={nodes.shoe_3.geometry} ><NodeToyMaterial data={data} /></mesh>
      <mesh  geometry={nodes.shoe_4.geometry} ><NodeToyMaterial data={data} /></mesh>
      <mesh  geometry={nodes.shoe_5.geometry} ><NodeToyMaterial data={data} /></mesh>
      <mesh  geometry={nodes.shoe_6.geometry} ><NodeToyMaterial data={data} /></mesh>
      <mesh  geometry={nodes.shoe_7.geometry} ><NodeToyMaterial data={data} /></mesh>
    </group>
  )
}